import Search from 'flarum/components/Search';
import LoadingIndicator from 'flarum/components/LoadingIndicator';
import ItemList from 'flarum/utils/ItemList';
import classList from 'flarum/utils/classList';
import Icon from 'flarum/common/components/Icon';
import UsersSearchSource from './UsersSearchResults';
export default class ChatSearchUser extends Search {
  oninit(vnode) {
    super.oninit(vnode);
  }
  sourceItems() {
    const items = new ItemList();
    this.state = this.attrs.state ?? {};
    if (app.forum.attribute('canSearchUsers')) items.add('users', new UsersSearchSource({
      state: app.search.neonchat
    }));
    return items;
  }
  updateMaxHeight() {}
  view(vnode) {
    const currentSearch = this.state.getInitialSearch();
    if (!this.state.getValue()?.length) {
      this.state.setValue(currentSearch || '');
    }
    app.current.searching = () => this.state.getValue();
    if (!this.sources) {
      this.sources = this.sourceItems().toArray();
    }
    if (!this.sources.length) return m("div", null);
    return m("div", {
      className: 'Search ' + classList({
        open: this.hasFocus,
        active: !!currentSearch,
        loading: !!this.loadingSources
      })
    }, m("div", {
      className: "Search-input SearchInput"
    }, m("input", {
      className: "FormControl",
      type: "search",
      placeholder: app.translator.trans('flatrate-live-chat.forum.chat.list.add_modal.search.placeholder'),
      value: this.state.getValue(),
      oninput: e => this.state.setValue(e.target.value),
      onfocus: () => this.hasFocus = true
    }), this.loadingSources ? m(LoadingIndicator, {
      size: "tiny",
      className: "Button Button--icon Button--link"
    }) : currentSearch ? m("button", {
      className: "Search-clear Button Button--icon Button--link",
      onclick: this.clear.bind(this)
    }, m(Icon, {
      name: "fas fa-times-circle"
    })) : ''), this.state.getValue() && this.hasFocus ? m("ul", {
      className: "Dropdown-menu Dropdown--Users Search-results"
    }, this.sources.map(source => source.view(this.state.getValue()))) : null);
  }
}
flarum.reg.add('flatrate-live-chat', 'forum/components/ChatSearchUser', ChatSearchUser);